// Convert an amount between two currencies using USD-based rates from
// GET /api/v1/exchange_rates ({ base: 'USD', rates: { USD:1, TWD:31.5, ... } }).
//
// Every rate is "units per 1 USD", so:
//   amountTo = amountFrom * (rate[to] / rate[from])
//
// Returns null when the inputs or rates are missing/invalid so callers can
// safely skip filling the amount field.
export const convert = (amount, from, to, rates, exponent = 0) => {
  const value = parseFloat(amount)
  if (!rates || isNaN(value)) { return null }

  const fromRate = rates[from]
  const toRate = rates[to]
  if (!fromRate || !toRate) { return null }

  const converted = value * (toRate / fromRate)
  if (!isFinite(converted)) { return null }

  const factor = Math.pow(10, exponent)
  return Math.round(converted * factor) / factor
}

// Unit price of 1 `from` in `to`, used for the "1 JPY ≈ 0.1963 TWD" hint.
export const unitRate = (from, to, rates) => convert(1, from, to, rates, 4)

export default convert
